// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.modal-overlay .modal-content {
  background: white;
  border-radius: 10px;
  width: 400px;
  height: 200px;
  text-align: center;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);
}
.modal-overlay .modal-content .select-group-text {
  margin-bottom: 15px;
  font-size: 20px;
  background: #0C3688;
  color: white;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding: 5px 0px;
}
.modal-overlay .modal-content .modal-body {
  padding: 20px;
}
.modal-overlay .modal-content select {
  width: 100%;
  padding: 8px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
}
.modal-overlay .modal-content .modal-actions {
  display: flex;
  justify-content: center;
  gap: 20px;
}
.modal-overlay .modal-content .cancel-btn,
.modal-overlay .modal-content .submit-btn {
  padding: 8px 12px;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.modal-overlay .modal-content .cancel-btn {
  background: #ccc;
}
.modal-overlay .modal-content .submit-btn {
  background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/component/GroupPopup/GroupPopup.scss"],"names":[],"mappings":"AAAA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AACJ;AACI;EACI,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,2CAAA;AACR;AACQ;EACI,mBAAA;EACA,eAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;EACA,6BAAA;EACA,gBAAA;AACZ;AAEQ;EACI,aAAA;AAAZ;AAGQ;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,kBAAA;AADZ;AAIQ;EACI,aAAA;EACA,uBAAA;EACA,SAAA;AAFZ;AAKQ;;EAEI,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;AAHZ;AAMQ;EACI,gBAAA;AAJZ;AAOQ;EACI,mEAAA;EACA,YAAA;AALZ","sourcesContent":[".modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 1000;\n\n    .modal-content {\n        background: white;\n        border-radius: 10px;\n        width: 400px;\n        height: 200px;\n        text-align: center;\n        box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.2);\n\n        .select-group-text {\n            margin-bottom: 15px;\n            font-size: 20px;\n            background: #0C3688;\n            color: white;\n            border-top-left-radius: 10px;\n            border-top-right-radius: 10px;\n            padding: 5px 0px;\n        }\n\n        .modal-body{\n            padding: 20px;\n        }\n\n        select {\n            width: 100%;\n            padding: 8px;\n            margin-bottom: 15px;\n            border: 1px solid #ccc;\n            border-radius: 5px;\n        }\n\n        .modal-actions {\n            display: flex;\n            justify-content: center;\n            gap: 20px;\n        }\n\n        .cancel-btn,\n        .submit-btn {\n            padding: 8px 12px;\n            border: none;\n            border-radius: 5px;\n            cursor: pointer;\n        }\n\n        .cancel-btn {\n            background: #ccc;\n        }\n\n        .submit-btn {\n            background: linear-gradient(277.62deg, #0c3688 10%, #2057c2 84.88%);\n            color: white;\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
